var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.show ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": _vm.componentId
    }
  }, [_vm._m(0)]) : _vm._e();

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-12 mb-4 text-center"
  }, [_c('span', {
    staticClass: "loader d-inline-block float-none align-middle"
  }), _c('span', {
    staticClass: "fa fa-spinner fa-spin"
  })]);

}]

export { render, staticRenderFns }